/**
 * @generated SignedSource<<b9864987fbe6f1e9ed399e377a100d35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditor_cateringOption$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_cateringOption">;
  readonly " $fragmentType": "RoomRatesTableRateEditor_cateringOption";
};
export type RoomRatesTableRateEditor_cateringOption$key = {
  readonly " $data"?: RoomRatesTableRateEditor_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditor_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditor_cateringOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesTableRateEditorForm_cateringOption"
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "be2a1f0ac3324e907fb4a12845019ed9";

export default node;
